import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-activity-drawer',
  templateUrl: './activity-drawer.component.html',
  styleUrls: ['./activity-drawer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActivityDrawerComponent {

}
